import React from 'react'

import Box from 'components_new/atoms/Box'
import Table from 'components_new/atoms/Table'
import TableCell from 'components_new/atoms/Table/TableCell'
import TableRow from 'components_new/atoms/Table/TableRow'
import Tooltip from 'components_new/atoms/Tooltip'
import Text from 'components_new/atoms/Text'
import { useTranslation } from 'language/translator'
import { IDashboardExampleSystem } from 'types/GlobalDashboardExample'

interface SystemsProps {
  sx?: object
  systems: IDashboardExampleSystem[]
}

const Systems = (props: SystemsProps) => {
  const { sx, systems } = props

  const { t } = useTranslation()

  if (systems === undefined) return null

  const otherSystems = systems.filter(
    (item) => item.category_slug !== 'portfolio'
  )

  const pmSystems = systems.filter((item) => item.category_slug === 'portfolio')

  return (
    <>
      <Text component="div" gutterBottom={true} variant="h5">
        {t('dashboards', 'systems_in_use_title')}
      </Text>
      <Table sx={sx}>
        {pmSystems && pmSystems.length > 0 ? (
          <TableRow>
            <TableCell>
              {t('dashboards', 'property_management_systems_title')}
            </TableCell>
            <TableCell align="right" sx={{ width: '0px' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 1
                }}
              >
                {pmSystems.map((system) => (
                  <>
                    <Tooltip key={system.slug} title={system.title}>
                      <span>
                        <img
                          src={system.url || undefined}
                          height={24}
                          width={24}
                        />
                      </span>
                    </Tooltip>
                    <Box sx={{ '&:last-child': { display: 'none' } }}>/</Box>
                  </>
                ))}
              </Box>
            </TableCell>
          </TableRow>
        ) : null}
        {otherSystems && otherSystems.length > 0 ? (
          <TableRow>
            <TableCell>{t('dashboards', 'other_systems_title')}</TableCell>
            <TableCell align="right" sx={{ width: '0px' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 1
                }}
              >
                {otherSystems.map((system) => (
                  <>
                    <Tooltip key={system.slug} title={system.title}>
                      <span>
                        <img
                          src={system.url || undefined}
                          height={24}
                          width={24}
                        />
                      </span>
                    </Tooltip>
                    <Box sx={{ '&:last-child': { display: 'none' } }}>/</Box>
                  </>
                ))}
              </Box>
            </TableCell>
          </TableRow>
        ) : null}
      </Table>
    </>
  )
}

export default Systems
